<script>
	import { Icon, TableView, StatusLight, Tooltip } from '@shopboxai/sb-portal-components';
	import GridCodeDialog from '../components/dialogs/list/GridCodeDialog.svelte';
	import CreateByLayoutOne from '../components/dialogs/list/CreateByLayoutOne.svelte';
	import CreateByLayoutTwo from '../components/dialogs/list/CreateByLayoutTwo.svelte';
	import CreateByLayoutThree from '../components/dialogs/list/CreateByLayoutThree.svelte';
	import CreateByLayoutFour from '../components/dialogs/list/CreateByLayoutFour.svelte';
	import CreateFromScratch from '../components/dialogs/list/CreateFromScratch.svelte';
	import GridArchiveDialog from '../components/dialogs/list/GridArchiveDialog.svelte';

	import { listGrid, postGrid, deleteGrid, checkGridState } from '../utils/api';
	import { copyToClipboard, continueTour } from '../utils/utils.js';
	import { createEventDispatcher } from 'svelte';
	import { tour } from '../utils/tour.js';

	const dispatch = createEventDispatcher();

	let grids;
	let runGridList = listGrid().then((r) => (grids = r));

	const editItem = (id, currency, platform) => {
		continueTour(3);
		dispatch('editItem', { id: id, currency: currency, platform: platform });
	};
	const submitArchive = async (payload) => {
		await deleteGrid({ id: payload.detail.id });
		runGridList = listGrid().then((r) => (grids = r));
	};
	const submitCopy = async (payload) => {
		copyToClipboard(payload.detail);
	};
	const isGridActive = async (gridId) => {
		try {
			let state = await checkGridState(gridId);

			return state ? 'Active' : 'Inactive';
		} catch (error) {
			return 'Inactive';
		}
	};
	const submitCreate = async (payload) => {
		continueTour(2);
		grids = [
			...grids,
			{
				id: payload.detail.id,
				name: payload.detail.name,
				updated_at: new Date().toISOString(),
				rows: 4
			}
		];
		await postGrid(payload.detail);

		// runGridList = listGrid();
	};

	let customProducts = [
		{ url: 'url', sku: 'sku' },
		{ url: 'url1', sku: 'sku1' }
	];
</script>

<header>
	<h1>Shopbox grid builder</h1>

	<div>
		<button class="secondary" on:click={() => tour.start()}>Start Guided Tour</button>

		<CreateFromScratch on:submit={submitCreate} />
	</div>
</header>
<div class="predefined">
	<h2>Explore our prebuilt layouts</h2>
	<CreateByLayoutOne on:submit={submitCreate} />
	<CreateByLayoutTwo on:submit={submitCreate} />
	<CreateByLayoutThree on:submit={submitCreate} />
	<CreateByLayoutFour on:submit={submitCreate} />
</div>

<TableView tableName="Your grids">
	<thead slot="thead">
		<th>Grid name</th>
		<th>Last Modified</th>
		<th>Status</th>
		<th>Actions</th>
	</thead>
	<tbody slot="tbody">
		{#await runGridList}
			<tr><p class="loader">Loading...</p> </tr>
		{:then}
			{#if Array.isArray(grids)}
				{#each grids as grid}
					{#if grid.name}
						<tr>
							<td>
								<p style="font-size:0.7rem;opacity:0.6">{grid.id}</p>
								<p>{grid.name}</p>
							</td>
							<td>
								<p>{new Date(grid.updated_at).toLocaleString()}</p>
							</td>
							<td>
								{#await isGridActive(grid.id)}
									Loading..
								{:then value}
									<Tooltip
										tip="Grids which have no user activity in the last 72 hours are marked as Inactive"
									>
										<StatusLight state={value == 'Active' ? true : false} />
									</Tooltip>
								{/await}
							</td>
							<td width="150px">
								<Tooltip tip="Edit grid">
									<button
										on:click={() => editItem(grid.id, grid.currency, grid.platform)}
										class={grid.id}
										title="Edit grid"><Icon name="settings" /></button
									>
								</Tooltip>

								<GridCodeDialog
									on:submit={submitCopy}
									data={{ id: grid.id, currency: grid.currency, rows: grid.num_cells }}
									on:submit={submitCopy}
								/>

								<GridArchiveDialog data={{ id: grid.id }} on:submit={submitArchive} />
							</td>
						</tr>
					{/if}
				{:else}
					<tr> <p class="no-data">No grids found for this client</p></tr>
				{/each}
			{:else}
				<tr><p class="no-data">No grids found for this client</p></tr>
			{/if}
		{/await}
	</tbody>
</TableView>

<style>
	h1 {
		font-family: 'Chivo', sans-serif;
		font-weight: 900;
	}

	h2 {
		font-family: 'Overpass';
		font-weight: 400;
		font-size: 24px;
		line-height: 30px;
		letter-spacing: 1.5px;
		color: #43414b;
	}
	header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 1em 0;
	}
	.loader,
	.no-data {
		margin: 1em 0;
	}
	.predefined {
		margin-top: 1em;
		margin-bottom: 2em;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr;
		gap: 1em;
	}
	.predefined h2 {
		grid-column: span 4;
	}
	.predefined :global(.create-button) {
		background: #ffffff;
		box-shadow: 0px 0px 8px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.16);
		border-radius: 4px;
		grid-column: span 1;
		padding: 1em;
		width: 100%;
		display: grid;
		grid-template-columns: min-content 2fr;
		place-content: center;
		align-items: center;
		min-height: 80px;
	}
	.predefined :global(.create-button div) {
		height: 100%;
		width: 100%;
		text-align: left;
		padding-left: 0.5em;
		padding-right: 0;
		color: #43414b;
	}
	.predefined :global(.create-button div p) {
		font-size: 12px;
	}
</style>
